<template>
  <v-row no-gutters v-if="existAlmostOneCoverage" class="coverages-month-view">
    <v-col
      v-for="coverage in coverages"
      :key="coverage?.month"
      class="month"
      :class="{ small: coverages.length < 4 }"
    >
      <div :class="isSmallDevice ? 'month-name-small' : 'month-name'">
        <v-row no-gutters align="center" class="pt-1">
          <!-- <span v-if="coverage?.covered">
            <template v-for="(item, i) in coverage?.codicePacchetto">
              <v-tooltip :key="i" top content-class="portal-tooltip-inverted">
                <template v-slot:activator="{ on }">
                  <img v-on="on" :src="getCoperturaImg(item)" alt />
                </template>
                <span>{{ $t(`codicePacchetto.${item}`) }}</span>
              </v-tooltip>
            </template></span
          > -->
          {{ getFullDate(coverage) | date("MMMM", $i18n.locale) }}&nbsp;{{
            coverage?.year
          }}
        </v-row>
      </div>
      <div
        class="month-wrapper"
        :class="{ checked: coverage?.covered, notchecked: !coverage?.covered }"
      >
        <div class="month-ball">
          <template v-if="coverage?.covered">
            <v-icon
              v-if="
                coverage?.codicePacchetto?.includes('FE1') ||
                coverage?.codicePacchetto?.includes('EMVA')
              "
            >
              done
            </v-icon>
            <v-tooltip
              v-else-if="coverage?.codicePacchetto?.includes('FEC')"
              bottom
              content-class="portal-tooltip"
            >
              <template #activator="{ on }">
                <v-icon v-on="on">fa-solid fa-c</v-icon>
              </template>
              <span>
                {{ $t("dashboard.coverages.coniugeCoverageTooltip") }}
              </span>
            </v-tooltip>
          </template>
          <v-icon v-else>fa-solid fa-xmark</v-icon>
        </div>
      </div>
    </v-col>
  </v-row>
  <v-card v-else flat color="secondary">
    <v-card-actions>
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-icon class="mr-2 mb-1" color="primary"
            >fa-solid fa-exclamation</v-icon
          >
          <span class="title font-weight-bold card-text-color">{{
            $t("coverageCeilings.coverage.noCoverage")
          }}</span>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      feImg: require("@/restricted-library/assets/images/w_fe_logo.png"),
      usImg: require("@/restricted-library/assets/images/w_us_logo.svg"),
      mhImg: require("@/restricted-library/assets/images/w_mh_logo.svg"),
      saImg: require("@/restricted-library/assets/images/w_sa_logo.png")
    };
  },
  computed: {
    isSmallDevice() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    coverages() {
      return this.$store.getters["coverages/getCoverages"];
    },
    existAlmostOneCoverage() {
      return this.coverages.length > 0;
    }
  },
  methods: {
    getFullDate(coverage) {
      return `${coverage?.year}-${coverage?.month}-01`;
    },
    getCoperturaImg(pacchetto) {
      if (pacchetto === "U1" || pacchetto === "UC") {
        return this.usImg;
      }
      if (pacchetto === "MH") {
        return this.mhImg;
      }
      if (pacchetto === "SANI") {
        return this.saImg;
      }
      return this.feImg;
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 4px;
  height: 15px;
  width: 15px;
}
.coverages-month-view {
  overflow: hidden;
  width: 100%;
  max-height: max-content;
  padding: 5px 5px 15px;
  background: var(--primary);
  border-radius: 10px;
  margin: 0 !important;
}
.month {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
.month.small {
  max-width: 150px;
}
.month-name {
  color: white;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto;
  text-align: center;
  text-transform: capitalize;
}
.month-name-small {
  color: white;
  font-size: 12px;
  font-weight: bold;
  margin: 0 auto;
  text-align: center;
  text-transform: capitalize;
}
.month-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: max-content;
  min-height: max-content;
  z-index: 1;
}
.month-wrapper::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 102%;
  height: 8px;
  border-radius: 2px;
  background: var(--secondary);
  z-index: -1;
}
.month-ball {
  margin: auto;
  height: 60px;
  width: 60px;
  background: var(--secondary);
  border-radius: 50%;
  text-align: center;
  position: relative;
  top: 5px;
}
.month-ball .v-icon {
  color: var(--secondary);
  margin-top: 18px;
  font-size: 25px;
}
.month-wrapper.checked .month-ball {
  color: white;
  background: var(--special);
}
.month-wrapper.checked::before {
  background: var(--special);
}
.month-wrapper.checked .v-icon {
  color: white;
}
.month-wrapper.notchecked .month-ball {
  color: var(--special);
  background: var(--secondary);
}
.month-wrapper.notchecked::before {
  background: var(--secondary);
}
.month-wrapper.notchecked .v-icon {
  color: var(--special);
}
</style>
